import React from 'react';
import {
  Card,
  ICON_CHECK,
  Message,
  Badge,
  CardSkeleton,
  ICON_ALERT_CIRCLE_OUTLINE,
  HStack,
  ICON_CHECKBOX_OUTLINE,
} from '@doveit/bricks';
import sortOptIns from '../../../contact/utils/sortOptIns';
import { optInTypeLabels } from '../../../labels/optInTypeLabels';
import { ApplicantOptIn, OptIn } from '../../../providers/api/dtos';

export interface BaseOptInsWidgetProps {
  optIns?: OptIn[] | ApplicantOptIn[];
  isLoading?: boolean;
  error?: boolean;
  primaryAction?: React.ReactNode;
  secondaryAction?: React.ReactNode;
}

const BaseOptInsWidget: React.FC<BaseOptInsWidgetProps> = ({
  optIns,
  isLoading = false,
  error = false,
  primaryAction,
  secondaryAction,
}) => {
  if (isLoading) {
    return <CardSkeleton aria-label="Dati consensi in caricamento" />;
  }

  if (error) {
    return (
      <Card aria-label="Errore nel caricamento dei consensi">
        <Card.Header
          title="Consensi"
          icon={{ path: ICON_ALERT_CIRCLE_OUTLINE }}
          color="critical"
        />
        <Card.Content>
          <Message message="Non è stato possibile caricare i dati dei consensi." />
        </Card.Content>
      </Card>
    );
  }

  return optIns ? (
    <Card aria-label="Sezione consensi">
      <Card.Header
        title="Consensi"
        icon={{ path: ICON_CHECKBOX_OUTLINE }}
        primaryActions={[primaryAction].filter(Boolean)}
        secondaryActions={[secondaryAction].filter(Boolean)}
      />

      <Card.Content>
        {optIns.length === 0 && (
          <Message
            message="Nessun consenso prestato."
            type="neutral"
          />
        )}

        {optIns.length > 0 && (
          <HStack>
            {sortOptIns(optIns).map((optIn) => (
              <Badge
                key={optIn.type}
                icon={ICON_CHECK}
                label={optInTypeLabels[optIn.type].label}
                size="XS"
              />
            ))}
          </HStack>
        )}
      </Card.Content>
    </Card>
  ) : null;
};

export default BaseOptInsWidget;
